import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
import { IReportRequest } from "./../../../model/request/report/IReportRequest";
import { IPagingReportResult } from "./../../../model/respone/report/IReportRespone";

export const eReportActionsObj = {
  LOAD_START: {} as IReportRequest,
  LOAD_SUCCESS: {} as IPagingReportResult,
  LOAD_ERROR: {} as string,

  CHANGE_REPORT_FILTER: "" as
    | "all"
    | "hoan-thanh"
    | "chua-hoan-thanh"
    | "nop-thua"
    | "all-co-cong-no",
  CHANGE_SINHVIEN_FILTER: "" as "all" | "dang-hoc" | "khac",
  CHANGE_REQUEST: {} as any,
  SHOW_MODAL_LIST_BIEN_LAI: "",
  CLOSE_MODAL_LIST_BIEN_LAI: undefined,
  SHOW_HIDE_FILTER: {} as boolean,
  EXPORT_EXCEL_BAO_CAO_START: {} as IReportRequest,
  EXPORT_EXCEL_BAO_CAO_SUCCESS: "",
  EXPORT_EXCEL_BAO_CAO_ERRR: "",
};
export const eReportActionIds = generateActionTypeIds(
  eReportActionsObj,
  "REPORT"
);
export type IReportActionTypes = IGenericActionType<
  typeof eReportActionsObj,
  "REPORT"
>;
